import {SubscriptionType} from "../components/constants/securspace-constants";
import AccountUtilService from "../services/account/AccountUtilService";
import {
  hasOwnerAccess,
  hasGateManagerAccess,
  hasGateClerkAccess,
  isAdminAccount,
  isBuyerAccount,
  isSupplierAccount,
  AccountWithRedirectContext, AccountWithUserType
} from "../util/AccountUtils";
import {MenuItemUrlParams} from "./nav/navs";
import {NavMenuItemType} from "../views/nav-menu/NavMenuSubmenuListItem";

interface CheckUrlContainer {
  pendingApprovalCount?: number;
}

export const getLandingRedirectPathForUser = (user?: AccountWithRedirectContext | null): string => {

  if (!user) {
    return "/";
  }

  let redirectPath: string;

  if (isSupplierAccount(user)) {
    redirectPath = getLandingRedirectPathForSupplierSubscriptionType(user);
  } else if (isBuyerAccount(user)) {
    redirectPath = "/search";
  } else if (isAdminAccount(user)) {
    redirectPath = "/login-as-account";
  } else {
    redirectPath = "/";
  }

  if (AccountUtilService.userNeedsTosConfirmation({
    type: user.type,
    userType: user.userType,
    hasAcceptedCurrentTos: user.hasAcceptedCurrentTos
  })) {
    redirectPath = "/confirm-account";
  }

  return redirectPath;
}

const getLandingRedirectPathForSupplierSubscriptionType = (
  user: AccountWithUserType & { subscriptionType?: string | null }
): string => {
  let redirectPath: string;

  switch (user?.subscriptionType) {
    case SubscriptionType.MARKETPLACE_ONLY:
      redirectPath = getLandingRedirectPathForMarketplaceOnly(user);
      break
    case SubscriptionType.GMS_PRO:
    case SubscriptionType.GMS_LITE:
      redirectPath = getLandingRedirectPathForGmsSubscription(user);
      break
    default:
      forceLogoutOnInvalidState();
      redirectPath = "/logout"; // unreachable but satisfies type checker
  }

  return redirectPath;
}

const getLandingRedirectPathForMarketplaceOnly = (user: AccountWithUserType): string => {
  let redirectPath: string;

  if (hasOwnerAccess(user)) {
    redirectPath = "/locations-profile";
  } else if (hasGateClerkAccess(user)) {
    redirectPath = "/gms-upgrade";
  } else {
    forceLogoutOnInvalidState();
    redirectPath = "/logout"; // unreachable but satisfies type checker
  }

  return redirectPath;
}

const getLandingRedirectPathForGmsSubscription = (user: AccountWithUserType): string => {

  let redirectPath: string;

  if (hasOwnerAccess(user)) {
    redirectPath = "/locations-profile";
  } else if (hasGateManagerAccess(user)) {
    redirectPath = "/approvals";
  } else if (hasGateClerkAccess(user)) {
    redirectPath = "/check-in";
  } else {
    forceLogoutOnInvalidState();
    redirectPath = "/logout"; // unreachable but satisfies type checker
  }

  return redirectPath;
}

const forceLogoutOnInvalidState = (): void => {
  window.location.href = "/logout";
}

export const formatMenuItemUrl = (menuItem: NavMenuItemType, badgeValue: number): string => {
  const params: string[] = [];
  if (menuItem?.urlParams && badgeValue > 0) {
    switch (menuItem?.urlParams) {
      case MenuItemUrlParams.BUYER_BOOKING:
        params.push("status=pending");
        break;
      //no default: if it is not a known MenuItemUrlCheck, we do not need to format its path
    }
  }

  if (menuItem?.external) {
    if (params.length === 0) {
      return menuItem.path;
    }
    const separator = menuItem.path.includes('?') ? '&' : '?';
    return `${menuItem.path}${separator}${params.join('&')}`;
  }

  return `/${menuItem.path}${params.length > 0 ? `?${params.join('&')}` : ''}`;
};

export const formatMenuItemUrl_old = (menuItem: NavMenuItemType, checkUrlContainer: CheckUrlContainer): string => {
  const params: string[] = [];
  if (menuItem?.urlParams && checkUrlContainer) {
    switch (menuItem?.urlParams) {
      case MenuItemUrlParams.BUYER_BOOKING:
        if (!!checkUrlContainer?.pendingApprovalCount && checkUrlContainer.pendingApprovalCount > 0) {
          params.push("status=pending");
        }
        break;
      //no default: if it is not a known MenuItemUrlCheck, we do not need to format its path
    }
  }

  return `/${menuItem.path}${params.length > 0 ? `?${params.join('&')}` : ''}`;
};
